// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1kGb8","title":"ClientInsurance_title__3JMWJ","itemText":"ClientInsurance_itemText__F9BcV"};